// src/services/notifications.js
import { getVapidKey, apiClient, unsubscribeFromPush } from './api';

// Вспомогательная функция для конвертации base64-строки
function urlBase64ToUint8Array(base64String) {
  const padding = '='.repeat((4 - base64String.length % 4) % 4);
  const base64 = (base64String + padding).replace(/-/g, '+').replace(/_/g, '/');
  const rawData = window.atob(base64);
  const outputArray = new Uint8Array(rawData.length);
  for (let i = 0; i < rawData.length; ++i) {
    outputArray[i] = rawData.charCodeAt(i);
  }
  return outputArray;
}

// Главная функция для подписки
export async function subscribeUserToPush() {
  // 1. Проверяем, доступен ли Service Worker
  if (!('serviceWorker' in navigator)) {
    throw new Error('Service Worker не поддерживается');
  }
  
  const registration = await navigator.serviceWorker.ready;

  // 2. Проверяем, есть ли уже подписка
  const existingSubscription = await registration.pushManager.getSubscription();
  if (existingSubscription) {
    console.log('Пользователь уже подписан.');
    return;
  }

  // 3. Получаем VAPID ключ с нашего бэкенда
  const response = await getVapidKey();
  const vapidPublicKey = response.data.publicKey;
  const convertedVapidKey = urlBase64ToUint8Array(vapidPublicKey);

  // 4. Запрашиваем подписку у браузера
  const newSubscription = await registration.pushManager.subscribe({
    userVisibleOnly: true, // Уведомления всегда будут видимы пользователю
    applicationServerKey: convertedVapidKey,
  });

  // 5. Отправляем объект подписки на наш бэкенд для сохранения
  await apiClient.post('/notifications/subscribe', newSubscription);
  
  console.log('Пользователь успешно подписан.');
}
export async function unsubscribeUserFromPush() {
  if (!('serviceWorker' in navigator)) {
    throw new Error('Service Worker не поддерживается');
  }

  const registration = await navigator.serviceWorker.ready;
  const existingSubscription = await registration.pushManager.getSubscription();

  if (!existingSubscription) {
    console.log('Пользователь не подписан.');
    return;
  }

  // 1. Отправляем запрос на наш бэкенд, чтобы он удалил запись из БД
  await unsubscribeFromPush(existingSubscription);

  // 2. После успешного удаления на сервере, отписываем пользователя в браузере
  const unsubscribed = await existingSubscription.unsubscribe();
  if (unsubscribed) {
    console.log('Пользователь успешно отписан.');
  }
}